import React, { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import ButtonSubmit from '../../components/ButtonSubmit'
import { ErrorMessage } from '../../components/ErrorMessage'
import { PasswordInput } from '../../components/PasswordInput'
import { RedefineSenha } from '../../services/accountService'
import '../Login/Login.css'

function RedefinirSenha() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const userName = searchParams.get('userName') ?? ''
  const token = searchParams.get('token') ?? ''

  const [novaSenha, setNovaSenha] = useState('')
  const [confirmacaoSenha, setConfirmacaoSenha] = useState('')
  const [erro, setErro] = useState('')
  const [senhaRedefinida, setSenhaRedefinida] = useState(false)

  function validaDados() {
    if (!novaSenha || !confirmacaoSenha) {
      setErro('Preencha a nova senha e a confirmação')
      return false
    }
    if (novaSenha !== confirmacaoSenha) {
      setErro('As senhas não conferem')
      return false
    }
    return true
  }

  async function redefineSenha(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    if (!userName || !token) {
      setErro('Link inválido. Solicite a redefinição de senha novamente.')
      return
    }

    if (!validaDados()) return

    try {
      await RedefineSenha(userName, token, novaSenha, confirmacaoSenha)
      setErro('')
      setSenhaRedefinida(true)
    } catch (error: any) {
      const mensagensErro = error.response?.data?.data

      if (Array.isArray(mensagensErro) && mensagensErro.length > 0) {
        setErro(mensagensErro.join(' '))
      } else {
        setErro(error.response?.data?.message ?? 'Não foi possível redefinir a senha.')
      }
    }
  }

  return (
    <div className="login">
      <div className="headerLogin">
        <h4>Sistema de Permissionários</h4>
      </div>

      <div className="loginUser">
        <h3>Redefinir senha</h3>

        {senhaRedefinida ? (
          <div className="formLogin col-11 mt-3">
            <p>Senha redefinida com sucesso.</p>
            <ButtonSubmit type="button" text="Ir para o login" onClick={() => navigate('/')} />
          </div>
        ) : (
          <form onSubmit={redefineSenha} className="formLogin col-11 mt-3">
            <div className="labelLogin">
              <label htmlFor="novaSenha" className="inputfield">
                Nova senha
              </label>
              <PasswordInput id="novaSenha" value={novaSenha} onChange={(e) => setNovaSenha(e.target.value)} />
            </div>
            <div className="labelLogin">
              <label htmlFor="confirmacaoSenha" className="inputfield">
                Confirmação de senha
              </label>
              <PasswordInput
                id="confirmacaoSenha"
                value={confirmacaoSenha}
                onChange={(e) => setConfirmacaoSenha(e.target.value)}
              />
            </div>

            <ErrorMessage text={erro} />

            <div className="col-12">
              <ButtonSubmit type="submit" text="Redefinir senha" />
            </div>
          </form>
        )}
      </div>
    </div>
  )
}

export default RedefinirSenha
